export default "__VITE_PUBLIC_ASSET__532c6a7b__"